import { parsedVehicle } from '@common/utils/methods/parsedVehicleForCarData';
import { Box, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { reducerPaths } from '../../../../../app/reducerPaths';
import theme from '../../../../../theme';
import { setAlertDialog } from '../../../../../toolkit/alertDialog/alertDialogSlice';
import {
  useLazyGetBiddersNegotiationListBuyNowQuery,
  useLazyGetBiddersNegotiationListQuery,
  useLazyGetNegotiationHistoryBuyNowQuery,
  useLazyGetNegotiationHistoryQuery,
} from '../../../../../toolkit/carsInNegotiation/carsInNegotiationApi';
import { useLazyGetBidHistoryQuery } from '../../../../../toolkit/liveAuction/liveAuctionApi';
import { useLazyGetVehicleQuery } from '../../../../../toolkit/vehicle/vehicleApi';
import { auctionTypes } from '../../../../../utils/constants/auction';
import { negotiationStatuses, negotiationStatusMapping } from '../../../../../utils/constants/negotiationStatuses';
import { routes } from '../../../../../utils/constants/routes';
import { getRGBAFromColor } from '../../../../../utils/methods/getCssVariables';
import CarDetails from '../../CarDetails';
import { mainContainer } from '../../VehicleInfoSidebarSx';
import CarBiddingNegotiation from '../components/CarBiddingNegotiation';
import NegotiationList from '../components/NegotiationList';
import { useCarsInNegotiationSocketEvents } from '../customHooks/useCarsInNegotiationSocketEvents';
import CarDetailSkeleton from '../../CarDetailsSkeleton';

const CarsInNegotiationDetailsSeller = (
  {
    // Bid_Id
    // selectedCar,
    // setSelectedCar,
    // getBiddersNegotiationListApiHandler,
    // getBiddersNegotiationListApiData
  }
) => {
  const { t } = useTranslation('carsInNegotiationDetails');
  const { t: buyNowCarDetailReadOnly } = useTranslation('buyNowCarDetailReadOnly');

  const images = [
    'https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480',
    'https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480',
    'https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480',
  ];

  const isMobile = useMediaQuery('(max-width:1300px)');

  // useRef start...
  const onMountRef = React.useRef({
    biddersList: false,
  });
  // useRef end...

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  const navigate = useNavigate();

  // useLocation...
  const location = useLocation();
  // useLocation...

  const Vehicle_Id =
    location?.pathname?.split?.(`${routes.carsInNegotiation}/`)?.[1] ||
    location?.pathname?.split?.(`${routes.carsInNegotiationBuyNow}/`)?.[1];

  const liveAuctionOrBuyNow = location?.pathname?.includes?.(`${routes.carsInNegotiationBuyNow}`)
    ? auctionTypes.buyNow
    : auctionTypes.liveAuction;

  console.log(liveAuctionOrBuyNow, `liveAuctionOrBuyNow`);

  // useSelector start...
  const carsInNegotiation = useSelector((store) => store[reducerPaths.carsInNegotiation]);
  const auth = useSelector((store) => store[reducerPaths.auth]);
  // useSelector end...

  // useState variables start...
  const [index, setIndex] = React.useState(0);
  const [selectedCar, setSelectedCar] = React.useState(null);
  const [activeBidder, setActiveBidder] = React.useState(null);
  const [negotiationStatus, setNegotiationStatus] = React.useState(negotiationStatuses.ongoing);
  const [currentLeftSidebarTab, setCurrentLeftSidebarTab] = React.useState(0);
  const [scrollToBottom, setScrollToBottom] = React.useState(true);
  // useState variables end...

  // Handlers start...
  const handleNext = () => {
    setIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrev = () => {
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const onBidderClick = async (bidder) => {
    setCurrentLeftSidebarTab(1);
  };

  const onPrevSectionHandler = () => {
    if (currentLeftSidebarTab === 0) {
      navigate(
        `${routes.dashboardNavigation}${
          liveAuctionOrBuyNow === auctionTypes.liveAuction ? routes.carsInNegotiation : routes.carsInNegotiationBuyNow
        }`
      );
    } else {
      setCurrentLeftSidebarTab(0);
    }
  };

  const onNewCounterOfferHandler = async (e) => {
    console.log(`onNewCounterOfferHandler`, e);
    if (liveAuctionOrBuyNow === auctionTypes.liveAuction) {
      await getNegotiationHistoryApiHandler({
        Vehicle_Id,
      });
    } else {
      await getNegotiationHistoryBuyNowApiHandler({
        Vehicle_Id,
      });
    }

    if (e?.senderId === auth?.user_id) {
      setScrollToBottom(true);
    }
  };

  const onBidAcceptedHandler = async (e) => {
    setNegotiationStatus(negotiationStatuses.accepted);
  };

  const onBidDeclinedHandler = async (e) => {
    setNegotiationStatus(negotiationStatuses.decline);
  };
  // Handlers end...

  // custom hooks start...
  const [getBiddersNegotiationListApiHandler, getBiddersNegotiationListApiData] =
    useLazyGetBiddersNegotiationListQuery();
  const [getBiddersNegotiationListBuyNowApiHandler, getBiddersNegotiationListBuyNowApiData] =
    useLazyGetBiddersNegotiationListBuyNowQuery();
  const [getNegotiationHistoryApiHandler, getNegotiationHistoryApiData] = useLazyGetNegotiationHistoryQuery();
  const [getNegotiationHistoryBuyNowApiHandler, getNegotiationHistoryBuyNowApiData] =
    useLazyGetNegotiationHistoryBuyNowQuery();
  const [getVehicleApiHandler, getVehicleApiData] = useLazyGetVehicleQuery();
  const [getBidHistoryApiHandler, getBidHistoryApiData] = useLazyGetBidHistoryQuery();
  useCarsInNegotiationSocketEvents({
    dealerId: activeBidder?.Dealer_Id || '',
    sellerId: auth?.user_id,
    Vehicle_Id,
    selectedVehicle: selectedCar,
    onNewCounterOfferHandler,
    onBidAcceptedHandler,
    onBidDeclinedHandler,
  });
  // custom hooks end...

  // useEffect start...
  React.useEffect(() => {
    if (Vehicle_Id) {
      (async () => {
        const res = await getVehicleApiHandler({
          Vehicle_Id,
        });

        console.log(res, `getVehicleApiHandler`);

        if (res?.error) {
          dispatch(
            setAlertDialog({
              open: true,
              title: t('Error'),
              message: res?.error?.data?.error || res?.error?.data?.message || t('Some error occured!'),
            })
          );
        } else {
          setSelectedCar(res?.data?.vehicle);
        }
      })();
    }
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (!Vehicle_Id) {
      return;
    }

    (async () => {
      await getBidHistoryApiHandler({
        vehicleId: Vehicle_Id,
      });
    })();
  }, [Vehicle_Id]);

  React.useEffect(() => {
    if (!Vehicle_Id) {
      return;
    }

    (async () => {
      if (liveAuctionOrBuyNow === auctionTypes.liveAuction) {
        await getNegotiationHistoryApiHandler({
          Vehicle_Id,
        });
      } else {
        await getNegotiationHistoryBuyNowApiHandler({
          Vehicle_Id,
        });
      }
    })();
  }, [Vehicle_Id]);

  React.useEffect(() => {
    const activeBidder =
      liveAuctionOrBuyNow === auctionTypes.liveAuction
        ? getBiddersNegotiationListApiData?.data?.TopBids?.length === 1
          ? getBiddersNegotiationListApiData?.data?.TopBids?.[0]
          : getBiddersNegotiationListApiData?.data?.TopBids?.find?.((bid) => {
              return bid?.bidder_status === 'active';
            })
        : getBiddersNegotiationListBuyNowApiData?.data?.TopBids;

    setActiveBidder({
      ...activeBidder,
      Dealer_Id: parseInt(activeBidder?.Dealer_Id),
    });
    setNegotiationStatus(negotiationStatusMapping[activeBidder?.negotation_status]);
  }, [getBiddersNegotiationListApiData?.data?.TopBids, getBiddersNegotiationListBuyNowApiData?.data?.TopBids]);

  React.useEffect(() => {
    if (selectedCar?.Vehicle_Id && selectedCar?.negotiation_status) {
      setNegotiationStatus(selectedCar?.negotiation_status);
    } else if (selectedCar?.Vehicle_Id && !selectedCar?.negotiation_status) {
      navigate(
        `${routes.dashboardNavigation}${
          liveAuctionOrBuyNow === auctionTypes.liveAuction ? routes.carsInNegotiation : routes.carsInNegotiationBuyNow
        }`
      );
    }
  }, [selectedCar?.negotiation_status]);

  React.useEffect(() => {
    if (!selectedCar?.Vehicle_Id) {
      return;
    }
    
    if (currentLeftSidebarTab === 0) {
      if (!selectedCar?.Vehicle_Id) {
        return;
      }
      if (onMountRef.current.biddersList) {
        (async () => {
          if (liveAuctionOrBuyNow === auctionTypes.liveAuction) {
            await getBiddersNegotiationListApiHandler({
              Vehicle_Id: selectedCar?.Vehicle_Id || '',
            });
          } else {
            await getBiddersNegotiationListBuyNowApiHandler({
              Vehicle_Id: selectedCar?.Vehicle_Id || '',
            });
          }
        })();
      } else {
        onMountRef.current.biddersList = true;
      }
    }
  }, [
    selectedCar?.Vehicle_Id,
    currentLeftSidebarTab,
    onMountRef.current?.biddersList
  ]);

  React.useEffect(() => {
    if (!Vehicle_Id) {
      return;
    }

    (async () => {
      console.log(liveAuctionOrBuyNow, `getBiddersNegotiationListApiHandler`);
      if (liveAuctionOrBuyNow === auctionTypes.liveAuction) {
        await getBiddersNegotiationListApiHandler({
          Vehicle_Id,
        });
      } else {
        await getBiddersNegotiationListBuyNowApiHandler({
          Vehicle_Id,
        });
      }
    })();
  }, [Vehicle_Id, liveAuctionOrBuyNow]);
  // useEffect end...

  console.log(
    activeBidder,
    negotiationStatus,
    selectedCar,
    getNegotiationHistoryBuyNowApiData,
    `CarsInNegotiationDetails_comp`
  );

  return (
    <Grid container spacing={1} sx={mainContainer}>
      {getVehicleApiData?.isFetching || !selectedCar ? (
        <CarDetailSkeleton />
      ) : (
        <>
          {/* Left Section */}
          <Grid
            size={{ xl: 2.8 - 0.2, lg: 4 - 0.2, md: 12, sm: 12, xs: 12 }}
            sx={{
              backgroundColor: getRGBAFromColor({
                color: theme.palette.primary.main,
                alpha: '0.085',
              }),
              padding: '1.5rem',
              borderRadius: '8px',
              boxShadow: '0 0.25rem 0.5rem rgba(0, 0, 0, 0.1)',
            }}
          >
            {currentLeftSidebarTab === 0 ? (
              <NegotiationList
                selectedCar={selectedCar}
                negotiationList={carsInNegotiation?.biddersNegotiationListData?.data || []}
                onBidderClick={onBidderClick}
                onPrevSectionHandler={onPrevSectionHandler}
                isLoading={
                  liveAuctionOrBuyNow === auctionTypes.liveAuction
                    ? getBiddersNegotiationListApiData?.isFetching
                    : getBiddersNegotiationListBuyNowApiData?.isFetching
                }
              />
            ) : (
              <>
                {negotiationStatus === negotiationStatuses.accepted ? (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      background: '#2BD24C',
                      padding: '1rem',
                      borderRadius: '1rem',
                      marginBottom: '1rem',
                    }}
                  >
                    <Typography
                      sx={{
                        color: theme.palette.background.paper,
                      }}
                    >
                      {t('Offer accepted. Sale completed successfully.')}
                    </Typography>
                  </Box>
                ) : null}

                {negotiationStatus === negotiationStatuses.decline ? (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      background: '#D22B2B',
                      padding: '1rem',
                      borderRadius: '1rem',
                      marginBottom: '1rem',
                    }}
                  >
                    <Typography
                      sx={{
                        color: theme.palette.background.paper,
                      }}
                    >
                      {t('The offer was declined. No deal was made.')}
                    </Typography>
                  </Box>
                ) : null}

                <CarBiddingNegotiation
                  selectedCar={selectedCar}
                  Vehicle_Id={Vehicle_Id}
                  dealerId={activeBidder?.Dealer_Id}
                  Bid_Id={
                    liveAuctionOrBuyNow === auctionTypes.liveAuction
                      ? getBiddersNegotiationListApiData?.data?.TopBids?.find?.((bid) => {
                          return parseInt(bid?.Dealer_Id) === activeBidder?.Dealer_Id;
                        })?.Bid_Id
                      : getBiddersNegotiationListBuyNowApiData?.data?.TopBids?.Bid_Id
                  }
                  negotiationHistory={
                    liveAuctionOrBuyNow === auctionTypes.liveAuction
                      ? getNegotiationHistoryApiData?.data?.negotiations_history_for_seller?.filter?.((bid) => {
                          return parseInt(bid?.dealer_id) === activeBidder?.Dealer_Id;
                        }) || []
                      : getNegotiationHistoryBuyNowApiData?.data?.negotiations_history_for_seller?.filter?.((bid) => {
                          return parseInt(bid?.dealer_id) === activeBidder?.Dealer_Id;
                        }) || []
                  }
                  negotiationStatus={negotiationStatus}
                  isLoading={
                    liveAuctionOrBuyNow === auctionTypes.liveAuction
                      ? getNegotiationHistoryApiData?.isFetching
                      : getNegotiationHistoryBuyNowApiData?.isFetching
                  }
                  onPrevSectionHandler={onPrevSectionHandler}
                  firstBid={
                    liveAuctionOrBuyNow === auctionTypes.liveAuction
                      ? getBiddersNegotiationListApiData?.data?.TopBids?.find?.((bid) => {
                          return parseInt(bid?.Dealer_Id) === activeBidder?.Dealer_Id;
                        })
                      : getBiddersNegotiationListBuyNowApiData?.data?.TopBids
                  }
                  scrollToBottom={scrollToBottom}
                  setScrollToBottom={setScrollToBottom}
                />
              </>
            )}
          </Grid>
          <Divider orientation={'vertical'} flexItem />
          {/* Right Section */}
          <Grid size={{ xl: 9.2 - 0.2, lg: 8 - 0.2, md: 12, sm: 12, xs: 12 }}>
            <CarDetails car={parsedVehicle(selectedCar)} showEdit />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default CarsInNegotiationDetailsSeller;
